function updateBannerOverlayHeight() {
  const banner = document.querySelector( '.e-stn--leadership-detail, .e-stn--author-banner' );
  const section = document.querySelector( '.e-stn--leadership-detail + section, .e-stn--author-banner + section' );
  
  if ( banner && section ) {
    let overlayHeight;

    if ( banner.classList.contains( 'e-stn--leadership-detail' ) ) {
      overlayHeight = banner.offsetHeight / 1.87; // leadership-detail ratio
      section.style.setProperty( '--lBannerOverlayHeight', `${overlayHeight}px` );
    } else if ( banner.classList.contains( 'e-stn--author-banner' ) ) {
      overlayHeight = banner.offsetHeight * 0.247; // author-banner ratio
      section.style.setProperty( '--aBannerOverlayHeight', `${overlayHeight}px` );
    }

  }
}

window.addEventListener( 'load', updateBannerOverlayHeight );
window.addEventListener( 'resize', updateBannerOverlayHeight );
